<template>
  <div class="num-cell" :class="{'full-width': isNum}">
    <div
      :style="{transform}"
      :class="{'num-change': animate&&flag}"
    >{{num}}</div>
    <div
      :style="{transform}"
      :class="{'num-change': animate&&flag}"
      v-for="i in listLength"
      :key="i"
    >{{ (num - i + 100) % 10 }}</div>
  </div>
</template>

<script>
export default {
  props: {
    num: String
  },
  data () {
    return {
      lastNum: '',
      animate: false,
      transform: ''
    }
  },
  computed: {
    flag () {
      const num = parseInt(this.num)
      const lastNum = parseInt(this.lastNum)
      if (Object.is(num, NaN) || Object.is(lastNum, NaN)) {
        return false
      }
      if (num - lastNum === 0) {
        return false
      }
      return true
    },
    isNum () {
      return Object.is(parseInt(this.num), NaN)
    },
    listLength () {
      if (this.flag) {
        if (this.num - this.lastNum > 0) {
          return this.num - this.lastNum + 10
        } else if (this.num - this.lastNum < 0) {
          return this.num - this.lastNum + 10 + 10
        } else {
          return 0
        }
      } else {
        return 0
      }
    }
  },
  watch: {
    num (to, from) {
      this.lastNum = from
      if (this.flag) {
        this.transform = `translateY(-${this.listLength}00%)`
        setTimeout(() => {
          this.animate = true
          this.transform = `translateY(0)`
          setTimeout(() => {
            this.animate = false
          }, 2000)
        }, 200)
      }
    }
  },
  created () {
    // console.log(this.num)
  }
}
</script>

<style scoped lang="less">
.num-cell {
  display: inline-block;
  width: .6em;
  height: 1em;
  overflow: hidden;
  line-height: 100%;
  &.full-width {
    width: 1em;
  }
  .num-change {
    transform: translateY(0);
    transition: all 2s;
  }
}
</style>
